// Call the function initially to set the class based on the checkbox state on page load
export default function fixedNavBodyPadding() {
    const navbarTop = document.querySelector('.navbar.fixed-top, header.fixed-top');
    const footerBottom = document.querySelector('footer.fixed-bottom');
    const headerElements = document.querySelectorAll('#topimage, .hero');

    // Handle padding for top fixed elements
    if (navbarTop) {
        const navbarHeight = navbarTop.offsetHeight;
        document.body.style.paddingTop = `${navbarHeight}px`;
    }

    // Handle padding for bottom fixed element
    if (footerBottom) {
        const footerHeight = footerBottom.offsetHeight;
        document.body.style.paddingBottom = `${footerHeight}px`;
    }

    // Add class based on header elements
    if (headerElements.length) {
        document.body.classList.add('js-pt', 'pt-lg-0-off');
    }
}
